import { Lock } from "lucide-react";
import { fmtDate } from "@/lib/api";

const label = (e) => e.toLowerCase().replace(/_/g, " ");

export const AuditTrail = ({ events, showMail = false }) => (
  <div data-testid="audit-trail" className="space-y-3">
    {events.length === 0 && <p className="text-sm text-slate-500">No events yet.</p>}
    {events.map((e) => (
      <div key={e.id} data-testid={`audit-event-${e.seq}`} className="rounded-lg border border-slate-200 dark:border-slate-800 p-4 bg-white dark:bg-slate-900/60">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <span className="text-[11px] font-mono text-slate-400">#{e.seq}</span>
            <span className="text-sm font-semibold capitalize">{label(e.event)}</span>
            <span className="text-[11px] uppercase tracking-wider text-slate-400">{e.actor_role}</span>
          </div>
          <span className="text-xs font-mono text-slate-500">{fmtDate(e.timestamp)}</span>
        </div>
        {showMail && e.mail_id && <p className="text-xs text-slate-500 mt-1 font-mono">mail {e.mail_id.slice(0, 8)}</p>}
        {e.context?.ip && (
          <p data-testid={`audit-context-${e.seq}`} className="text-[11px] font-mono text-slate-500 mt-2">
            ip {e.context.ip} · device {e.context.device_fingerprint?.slice(0, 12)}
            {e.mail_ref?.reply_chain_id && <> · chain {e.mail_ref.reply_chain_id.slice(0, 8)}</>}
          </p>
        )}
        <div className="mt-3 grid gap-1.5 text-xs">
          <div className="flex gap-2 items-start"><Lock size={12} className="mt-1 text-emerald-600 shrink-0" /><span className="text-slate-500 w-12 shrink-0">hash</span><span className="hash">{e.hash}</span></div>
          <div className="flex gap-2 items-start"><span className="w-3 shrink-0" /><span className="text-slate-500 w-12 shrink-0">prev</span><span className="hash !text-slate-500">{e.prev_hash}</span></div>
        </div>
      </div>
    ))}
  </div>
);
